(function () {
  "use strict";

  var MAX_FILE_SIZE = 50 * 1024 * 1024;
  var ALLOWED_EXTENSIONS = ["png", "jpg", "jpeg", "webp", "pdf", "ai", "eps"];
  var SIZE_PRESETS = [
    [1, 1],
    [2, 2],
    [3, 2],
    [3, 3],
    [4, 3],
    [4, 4]
  ];

  function calcQuote(state) {
    var widthInches = state.unit === "cm" ? state.width / 2.54 : state.width;
    var heightInches = state.unit === "cm" ? state.height / 2.54 : state.height;
    var area = Math.max(0.25, widthInches * heightInches);
    var formatRate = state.format === "Roll labels" ? 1.12 : state.format === "Label sheets" ? 1.08 : 1;
    var materialRate =
      state.material === "Silver foil" ? 1.35 :
      state.material === "Freezer grade" ? 1.22 :
      state.material === "Clear" ? 1.14 :
      state.material === "Glossy" ? 1.06 : 1;
    var msi = (area * state.quantity) / 1000;
    var adjustedMsi = msi * formatRate * materialRate;
    var standardPrice = adjustedMsi * 4.5;
    var midTierPrice = adjustedMsi * 4;
    var highTierPrice = adjustedMsi * 3.75;
    var msiRate = standardPrice <= 100 ? 4.5 : midTierPrice <= 450 ? 4 : highTierPrice <= 999 ? 3.75 : 3.25;
    var price = Math.max(32, Math.round(adjustedMsi * msiRate * 100) / 100);
    return { price: price, msiRate: msiRate };
  }

  function setActive(buttons, matchFn) {
    buttons.forEach(function (btn) {
      var on = matchFn(btn);
      btn.classList.toggle("active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var em = btn.querySelector("em");
      if (on && !em) {
        em = document.createElement("em");
        em.textContent = "✓";
        btn.appendChild(em);
      } else if (!on && em) {
        em.remove();
      }
    });
  }

  function presetLabel(w, h, unit) {
    if (unit === "in") return w + " × " + h + " in";
    var wd = (w * 2.54).toFixed(w === 1 ? 2 : 1);
    var hd = (h * 2.54).toFixed(h === 1 ? 2 : 1);
    return wd + " × " + hd + " cm";
  }

  function init(root) {
    if (!root || root.dataset.qbReady === "true") return;
    root.dataset.qbReady = "true";

    var state = {
      format: "Die-cut labels",
      material: "Matte",
      rollShape: "Round",
      rollDirection: "TOP",
      width: 2,
      height: 2,
      unit: "in",
      quantity: 250,
      artwork: null,
      previewUrl: "",
      fileError: "",
      cartError: "",
      adding: false,
      added: false
    };

    var formatBtns = root.querySelectorAll("[data-format]");
    var materialBtns = root.querySelectorAll("[data-material]");
    var rollSetup = root.querySelector("[data-roll-setup]");
    var rollShapeBtns = root.querySelectorAll("[data-roll-shape]");
    var rollDirBtns = root.querySelectorAll("[data-roll-direction]");
    var presetBtns = root.querySelectorAll("[data-preset-w]");
    var widthInput = root.querySelector("[data-width]");
    var heightInput = root.querySelector("[data-height]");
    var unitLabels = root.querySelectorAll("[data-unit-label]");
    var unitBtns = root.querySelectorAll("[data-unit]");
    var qtyInput = root.querySelector("[data-quantity]");
    var qtyBtns = root.querySelectorAll("[data-qty]");
    var fileDrop = root.querySelector("[data-file-drop]");
    var fileInput = root.querySelector("[data-file-input]");
    var dropTitle = root.querySelector("[data-drop-title]");
    var uploaded = root.querySelector("[data-uploaded-file]");
    var previewEl = root.querySelector("[data-file-preview]");
    var fileNameEl = root.querySelector("[data-file-name]");
    var fileMetaEl = root.querySelector("[data-file-meta]");
    var fileErrorEl = root.querySelector("[data-file-error]");
    var fileRemove = root.querySelector("[data-file-remove]");
    var specEl = root.querySelector("[data-spec-summary]");
    var priceEl = root.querySelector("[data-price]");
    var priceEachEl = root.querySelector("[data-price-each]");
    var addBtn = root.querySelector("[data-add-btn]");
    var cartErrorEl = root.querySelector("[data-cart-error]");

    qtyBtns.forEach(function (btn) {
      var n = Number(btn.getAttribute("data-qty"));
      btn.textContent = n.toLocaleString();
    });

    function isPresetActive(w, h) {
      var m = state.unit === "cm" ? 2.54 : 1;
      return Math.abs(state.width - w * m) < 0.02 && Math.abs(state.height - h * m) < 0.02;
    }

    function revokePreview() {
      if (state.previewUrl) {
        URL.revokeObjectURL(state.previewUrl);
        state.previewUrl = "";
      }
    }

    function selectFile(file) {
      state.added = false;
        state.cartError = "";
      state.fileError = "";
      if (!file) return;
      var ext = (file.name.split(".").pop() || "").toLowerCase();
      if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
        state.artwork = null;
        revokePreview();
        state.fileError = "Please upload PNG, JPG, WEBP, PDF, AI, or EPS artwork.";
        render();
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        state.artwork = null;
        revokePreview();
        state.fileError = "That file is over 50 MB. Please upload a smaller version.";
        render();
        return;
      }
      state.artwork = file;
      revokePreview();
      if (file.type && file.type.indexOf("image/") === 0) {
        state.previewUrl = URL.createObjectURL(file);
      }
      render();
    }

    function render() {
      setActive(formatBtns, function (b) { return b.getAttribute("data-format") === state.format; });
      setActive(materialBtns, function (b) { return b.getAttribute("data-material") === state.material; });
      if (rollSetup) rollSetup.hidden = state.format !== "Roll labels";
      setActive(rollShapeBtns, function (b) { return b.getAttribute("data-roll-shape") === state.rollShape; });
      setActive(rollDirBtns, function (b) { return b.getAttribute("data-roll-direction") === state.rollDirection; });

      presetBtns.forEach(function (btn) {
        var w = Number(btn.getAttribute("data-preset-w"));
        var h = Number(btn.getAttribute("data-preset-h"));
        btn.classList.toggle("active", isPresetActive(w, h));
        var label = btn.querySelector("[data-preset-label]");
        if (label) label.textContent = presetLabel(w, h, state.unit);
      });

      var max = state.unit === "in" ? 24 : 60;
      widthInput.max = max;
      heightInput.max = max;
      widthInput.setAttribute("aria-label", "Width in " + state.unit);
      heightInput.setAttribute("aria-label", "Height in " + state.unit);
      if (document.activeElement !== widthInput) widthInput.value = state.width;
      if (document.activeElement !== heightInput) heightInput.value = state.height;
      unitLabels.forEach(function (el) { el.textContent = state.unit; });
      unitBtns.forEach(function (btn) {
        btn.classList.toggle("active", btn.getAttribute("data-unit") === state.unit);
      });

      if (document.activeElement !== qtyInput) qtyInput.value = state.quantity;
      qtyBtns.forEach(function (btn) {
        btn.classList.toggle("active", Number(btn.getAttribute("data-qty")) === state.quantity);
      });

      if (state.artwork) {
        fileDrop.hidden = true;
        uploaded.hidden = false;
        previewEl.innerHTML = "";
        if (state.previewUrl) {
          var img = document.createElement("img");
          img.src = state.previewUrl;
          img.alt = "Artwork preview";
          previewEl.appendChild(img);
        } else {
          var span = document.createElement("span");
          span.textContent = (state.artwork.name.split(".").pop() || "").toUpperCase();
          previewEl.appendChild(span);
        }
        fileNameEl.textContent = state.artwork.name;
        var sizeMb = state.artwork.size / 1024 / 1024;
        var sizeLabel = sizeMb.toFixed(state.artwork.size > 1024 * 1024 ? 1 : 2) + " MB";
        fileMetaEl.textContent = sizeLabel + " · Ready for proofing";
      } else {
        fileDrop.hidden = false;
        uploaded.hidden = true;
      }

      if (state.fileError) {
        fileErrorEl.hidden = false;
        fileErrorEl.textContent = state.fileError;
        fileDrop.classList.add("has-error");
      } else {
        fileErrorEl.hidden = true;
        fileErrorEl.textContent = "";
        fileDrop.classList.remove("has-error");
      }

      var quote = calcQuote(state);
      var chips = [state.format];
      if (state.format === "Roll labels") {
        chips.push(state.rollShape);
        chips.push(state.rollDirection + " unwind");
      }
      chips.push(state.material);
      chips.push(state.width + " × " + state.height + " " + state.unit);
      chips.push(state.quantity.toLocaleString() + " labels");
      chips.push("$" + quote.msiRate.toFixed(2) + " / MSI");
      specEl.innerHTML = chips.map(function (c) { return "<span>" + c + "</span>"; }).join("");

      priceEl.textContent = "$" + quote.price.toFixed(2);
      priceEachEl.textContent = "$" + (quote.price / state.quantity).toFixed(2) + " each · $" + quote.msiRate.toFixed(2) + " / MSI";
      addBtn.disabled = state.adding;
      if (state.adding) {
        addBtn.innerHTML = "Adding…";
      } else if (state.added) {
        addBtn.innerHTML = "Added to cart ✓";
      } else {
        addBtn.innerHTML = "Add to cart<span>→</span>";
      }
      if (cartErrorEl) {
        if (state.cartError) {
          cartErrorEl.hidden = false;
          cartErrorEl.textContent = state.cartError;
        } else {
          cartErrorEl.hidden = true;
          cartErrorEl.textContent = "";
        }
      }
    }

    formatBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.format = btn.getAttribute("data-format");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    materialBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.material = btn.getAttribute("data-material");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    rollShapeBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.rollShape = btn.getAttribute("data-roll-shape");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    rollDirBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.rollDirection = btn.getAttribute("data-roll-direction");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    presetBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var w = Number(btn.getAttribute("data-preset-w"));
        var h = Number(btn.getAttribute("data-preset-h"));
        var m = state.unit === "cm" ? 2.54 : 1;
        state.width = Number((w * m).toFixed(2));
        state.height = Number((h * m).toFixed(2));
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    widthInput.addEventListener("input", function () {
      state.width = Math.max(0.25, Number(widthInput.value));
      state.added = false;
        state.cartError = "";
      render();
    });
    heightInput.addEventListener("input", function () {
      state.height = Math.max(0.25, Number(heightInput.value));
      state.added = false;
        state.cartError = "";
      render();
    });
    unitBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = btn.getAttribute("data-unit");
        if (next === state.unit) return;
        var m = next === "cm" ? 2.54 : 1 / 2.54;
        state.width = Number((state.width * m).toFixed(2));
        state.height = Number((state.height * m).toFixed(2));
        state.unit = next;
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    qtyInput.addEventListener("input", function () {
      state.quantity = Math.min(10000000, Math.max(1, Math.floor(Number(qtyInput.value) || 1)));
      state.added = false;
        state.cartError = "";
      render();
    });
    qtyBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.quantity = Number(btn.getAttribute("data-qty"));
        state.added = false;
        state.cartError = "";
        render();
      });
    });

    fileDrop.addEventListener("click", function () { fileInput.click(); });
    fileDrop.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        fileInput.click();
      }
    });
    fileDrop.addEventListener("dragenter", function (event) {
      event.preventDefault();
      fileDrop.classList.add("is-dragging");
      dropTitle.textContent = "Drop it right here";
    });
    fileDrop.addEventListener("dragover", function (event) { event.preventDefault(); });
    fileDrop.addEventListener("dragleave", function () {
      fileDrop.classList.remove("is-dragging");
      dropTitle.textContent = "Drop artwork or browse";
    });
    fileDrop.addEventListener("drop", function (event) {
      event.preventDefault();
      fileDrop.classList.remove("is-dragging");
      dropTitle.textContent = "Drop artwork or browse";
      selectFile(event.dataTransfer.files && event.dataTransfer.files[0]);
    });
    fileInput.addEventListener("change", function (event) {
      selectFile(event.target.files && event.target.files[0]);
    });
    fileInput.addEventListener("click", function (event) { event.stopPropagation(); });
    fileRemove.addEventListener("click", function () {
      state.artwork = null;
      state.fileError = "";
      state.added = false;
        state.cartError = "";
      revokePreview();
      fileInput.value = "";
      render();
    });

    function sizeLabel() {
      return state.width + " × " + state.height + " " + state.unit;
    }

    function showCartError(message) {
      state.adding = false;
      state.added = false;
      state.cartError = message || "Could not add to cart.";
      render();
    }

    function updateCartCount(count) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
      });
    }

    function addToCart() {
      if (state.adding) return;
      var config = window.themeCart || {};
      var variantId = config.variantId;
      var cartUrl = config.cartUrl || "/cart";
      var addUrl = config.addUrl || "/cart/add.js";
      var cartJsUrl = config.cartJsUrl || "/cart.js";

      if (!variantId) {
        showCartError("No quote product is set. In Theme settings, choose Quote product (or create a product with handle custom-labels).");
        return;
      }

      state.adding = true;
      state.added = false;
      state.cartError = "";
      render();

      var properties = {
        Format: state.format,
        Material: state.material,
        Size: sizeLabel(),
        Quantity: String(state.quantity) + " labels",
        "Artwork filename": state.artwork ? state.artwork.name : "To be sent after ordering"
      };
      if (state.format === "Roll labels") {
        properties["Roll shape"] = state.rollShape;
        properties.Unwind = state.rollDirection + " unwind";
      }
      properties["Estimated total"] = "$" + calcQuote(state).price.toFixed(2);

      fetch(addUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties
        })
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            try {
              data = text ? JSON.parse(text) : {};
            } catch (err) {
              data = { description: text };
            }
            if (!res.ok || (data.status && Number(data.status) >= 400)) {
              throw new Error(data.description || data.message || "Could not add to cart.");
            }
            return data;
          });
        })
        .then(function () {
          return fetch(cartJsUrl, {
            credentials: "same-origin",
            headers: { Accept: "application/json" }
          }).then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count !== "undefined") {
            updateCartCount(cart.item_count);
          }
          state.adding = false;
          state.added = true;
          render();
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          showCartError(err && err.message ? err.message : "Could not add to cart.");
        });
    }

    root.addEventListener("submit", function (event) {
      event.preventDefault();
      addToCart();
    });

    render();
  }

  function boot() {
    document.querySelectorAll("[data-quote-builder]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
